import React, { useEffect, useState } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Card from "react-bootstrap/Card";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { createApplication, getTests } from "../Store/Thunk";
import { updateTestLocally } from "../Store";

import { ScoringScale } from "./ScoringScale";
import ScrollableCard from "../../../../SharedComponents/ScrollableCard";
import TestList from "./TestList/TestList";
import { ButtonGroup, ToggleButton } from "react-bootstrap";

export default function Test() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const test = useSelector((state) => state.test.test);
  const tests = useSelector((state) => state.test.tests);
  const [isArchiveActive, setIsArchiveActive] = useState(false);

  useEffect(() => {
    dispatch(getTests());
  }, [dispatch]);

  useEffect(() => {
    if (test.cleanScoringComp) {
      dispatch(updateTestLocally({ key: "cleanScoringComp", value: false }));
    }
  });

  const archivedTests = tests?.filter((test) => test.isArchive);
  const nonArchivedTests = tests?.filter((test) => !test.isArchive);

  const UpdateTestProperty = (key, value) => {
    dispatch(updateTestLocally({ key, value }));
  };

  const createTest = () => {
    const testToCreate = {
      ...test,
      Duration: test.Duration * 60, // Convert minutes to seconds
    };
    dispatch(createApplication(testToCreate));
  };

  const isButtonDisabled = () => {
    if (test.Name && test.Duration && test.scales?.length) return false;
    return true;
  };

  return (
    <div>
      <Card body className="mb-3 default-card admin-form">
        <Row>
          <Col xs={12} md={8}>
            <h6>{t("testName")}</h6>
            <InputGroup className="mb-3">
              <Form.Control
                placeholder={t("enterTestName")}
                value={test.Name}
                onChange={(e) => UpdateTestProperty("Name", e.target.value)}
              />
            </InputGroup>
          </Col>

          <Col xs={12} md={2}>
            <h6>{t("duration")}</h6>
            <InputGroup className="mb-3">
              <Form.Control
                placeholder={t("enterDuration")}
                type="number"
                value={test.Duration}
                onChange={(e) => UpdateTestProperty("Duration", e.target.value)}
              />
            </InputGroup>
          </Col>

          <Col xs={12} md={2} className="mb-3">
            <Button
              style={{ height: "100%", width: "100%" }}
              variant="primary"
              onClick={createTest}
              disabled={isButtonDisabled()}
            >
              {t("create")}
            </Button>
          </Col>
        </Row>
        <ScoringScale
          HandleAddScoreScale={(data) => UpdateTestProperty("scales", data)}
          scale={test?.scales}
          clean={test.cleanScoringComp}
        />
      </Card>

      <Row className={"justify-content-between"}>
        <Col xs={"auto"}>
          <h5>
            <span>{isArchiveActive ? t("Archived") : t("NonArchived")}</span>
            <span> {t("tests")}</span>
          </h5>
        </Col>
        <Col xs={"auto"}>
          <Row className={"mx-0"}>
            <ButtonGroup className="mb-2" size="sm">
              <ToggleButton
                id={"test-nonarchived-button"}
                type="radio"
                className={`button align-content-center text-nowrap ${!isArchiveActive ? "success primary" : "secondary bg-white"}`}
                style={{ fontSize: "0.875rem", padding: "0.25rem 0.75rem" }}
                value={"nonarchived"}
                checked={!isArchiveActive}
                onClick={() => setIsArchiveActive(false)}
              >
                {t("NonArchived") + ` (${nonArchivedTests?.length})`}
              </ToggleButton>
              <ToggleButton
                id={"test-archived-button"}
                type="radio"
                className={`button align-content-center text-nowrap ${isArchiveActive ? "success primary" : "secondary bg-white"}`}
                style={{ fontSize: "0.875rem", padding: "0.25rem 0.75rem" }}
                value={"archived"}
                checked={isArchiveActive}
                onClick={() => setIsArchiveActive(true)}
              >
                {t("Archived") + ` (${archivedTests?.length})`}
              </ToggleButton>
            </ButtonGroup>
          </Row>
        </Col>
      </Row>
      <ScrollableCard>
        <TestList isTest={true} isArchiveActive={isArchiveActive} />
      </ScrollableCard>
    </div>
  );
}
